import React from 'react';
import FontAwesome from 'react-fontawesome';

const RedlineRequestText = ({ other }) => {
  let redlineText = 'This section has been redlined';
  if (other) {
    redlineText =
      'Other parts of this agreement have been redlined and should be reviewed.';
  }

  return (
    <div className={`change-redline-request ${other && 'other-redline'}`}>
      <FontAwesome name="exclamation-triangle" />
      <div className="change-content">
        <span className="text-red">{redlineText}</span>
      </div>
    </div>
  );
};

export default RedlineRequestText;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/RedlineRequestText.js